import React , {useEffect, useState} from 'react';
import { Input, Label, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import Swal from 'sweetalert2';
import {
    useNavigate
} from "react-router-dom";

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';
import Loading from '../../../components/modales/loadingModal';

//Utils
import { glosarioProceso1 } from '../utils/glosarioSolicitudes';

//Funciones
import { singleFileUploader, deleteFile } from '../../../utils/FirebaseStorage/FirebaseStorage';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const dataListaChequeo = functionsHttpsCallable('ape_getDataListaChequeo');
const envioCorreoLider = functionsHttpsCallable('correos_envioCorreoLider');
const envioCorreo = functionsHttpsCallable('correos_envioCorreoAPE');
const listadoReclutadores = functionsHttpsCallable('ape_listadoReclutadores');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalRevision = (props)=>{  
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const navigate  = useNavigate(); 
    const [updFile, setUpdFile] = useState([]);
    const [tempKey, setTempKey] = useState(undefined);
    const [listaChequeo, setListaChequeo] =  useState(undefined);
    const [agenciaSPE1, setAgenciaSPE1] = useState(props.dataApe.agenciaSPE1 ?? undefined);
    const [codigoSPE1, setCodigoSPE1] = useState(props.dataApe.codigoSPE1 ?? undefined);
    const [agenciaSPE2, setAgenciaSPE2] = useState(props.dataApe.agenciaSPE2 ?? undefined);
    const [codigoSPE2, setCodigoSPE2] = useState(props.dataApe.codigoSPE2 ?? undefined);
    const [agenciaSPE3, setAgenciaSPE3] = useState(props.dataApe.agenciaSPE3 ?? undefined);
    const [codigoSPE3, setCodigoSPE3] = useState(props.dataApe.codigoSPE3 ?? undefined);
    const [agenciaSPE4, setAgenciaSPE4] = useState(props.dataApe.agenciaSPE4 ?? undefined);
    const [codigoSPE4, setCodigoSPE4] = useState(props.dataApe.codigoSPE4 ?? undefined);
    const [agenciaSPE5, setAgenciaSPE5] = useState(props.dataApe.agenciaSPE5 ?? undefined);
    const [codigoSPE5, setCodigoSPE5] = useState(props.dataApe.codigoSPE5 ?? undefined);
    const [analisisSPE, setAnalisisSPE] = useState(props.dataApe.analisisSPE ?? undefined);
    const [anillo, setAnillo] = useState(props.dataApe.anillo ?? undefined);
    const [sector, setSector] = useState(props.dataApe.sector ?? undefined);
    const [loading, setLoading] = useState(true);
    const [reclutadores, setReclutadores] = useState(true);
    const [elaboradoPor, setElaboradorPor] = useState(true);
    
    useEffect(() => {
        async function getReclutadores () {
            const reclReq = await listadoReclutadores({ cod_empr: userData.codigoEmpresa })
            setReclutadores([...reclReq.data.data])
        }
        async function getDataListaChequeo() {
            props.setLoading(true)
            const req = await dataListaChequeo({
                "cod_empr": 537,
                "ape": props.id
            })
            if (req.data.data[0]) setListaChequeo({ ...req.data.data[0] })
        }
        getDataListaChequeo()
        props.setLoading(false)
        getReclutadores()
        setLoading(false)
    }, [])

    const listadoAdjuntos = [
        {
            required: true,
            name: 'Hoja de vida',
            key: 'HOJA_DE_VIDA',
        },
        {
            required: true,
            name: 'Cédula',
            key: 'CEDULA',
        },
        {
            required: true,
            name: 'Certificado EPS',
            key: 'CERTIFICADO_EPS',
        },
        {
            required: true,
            name: 'Certificado Cesantías',
            key: 'CERTIFICADO_CESANTIAS',
        },
        {
            required: true,
            name: 'Certificado Fondo de Pensiones',
            key: 'CERTIFICADO_PENSIONES',
        },
        {
            required: false,
            name: 'Certificado Vacunas',
            key: 'CERTIFICADO_VACUNAS',
        },
        {
            required: true,
            name: 'Certificado Bancario',
            key: 'CERTIFICADO_BANCARIO',
        },
        {
            required: false,
            name: 'Certificado Residencia',
            key: 'CERTIFICADO_RESIDENCIA',
        },
        {
            required: true,
            name: 'Foto',
            key: 'FOTO',
        },
    ]

    const listadoAdjuntos2 = [
        {
            required: true,
            name: 'Examenes médicos',
            key: 'EXAMENES',
        },
        {
            required: true,
            name: 'Prueba HSEQ',
            key: 'PRUEBAS_HSEQ',
        },
        {
            required: false,
            name: 'Prueba Técnicas',
            key: 'PRUEBAS_TECNICA',
        },
        {
            required: false,
            name: 'Prueba Habilidades',
            key: 'PRUEBAS_HB',
        },
        {
            required: true,
            name: 'Entrevista',
            key: 'ENTREVISTA',
        },
        {
            required: true,
            name: 'Autorización de Antecedentes',
            key: 'AUTORIZACION_ANTECEDENTES',
        },
        {
            required: true,
            name: 'Conflicto de Interés',
            key: 'CONFLICTO_INTERES',
        },
        {
            required: true,
            name: 'Acta de Aceptacion al Proceso',
            key: 'ACEPTACION_PROCESO',
        },
        {
            required: true,
            name: 'Respesta Inspektor',
            key: 'RESPUESTA_INSPEKTOR',
        },
        {
            required: false,
            name: 'Respuesta Estudio de Seguridad',
            key: 'RESPUESTA_ESTUDIO_SEGURIDAD',
        },
        {
            required: false,
            name: 'Respuesta Poligrafía',
            key: 'RESPUESTA_POLIGRAFIA',
        },
        {
            required: true,
            name: 'Validación de Hoja de vida',
            key: 'VALIDACION',
        },
        {
            required: true,
            name: 'Publicacion de Hoja de vida',
            key: 'ANILLO',
        },
        {
            required: true,
            name: 'Remisión',
            key: 'REMISION',
        },
    ]

    const handleValidacionFinal =()=>{
        let val = true
        listadoAdjuntos.forEach((adj)=>{
            val = val && (adj.required ? fileReadyToUpload(adj.key) || fileExist(adj.key) : true)
        })
        listadoAdjuntos2.forEach((adj)=>{
            val = val && (adj.required ? fileReadyToUpload(adj.key) || fileExist(adj.key) : true)
        })
        return val
    }
   
    const pasoAContratacion = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                agenciaSPE1,
                codigoSPE1,
                agenciaSPE2,
                codigoSPE2,
                agenciaSPE3,
                codigoSPE3,
                agenciaSPE4,
                codigoSPE4,
                agenciaSPE5,
                codigoSPE5,
                anillo,
                sector,
                elaboradoPorReclutamiento: elaboradoPor,
                analisisSPE,
                cod_actu: props.dataApe.flujo.cedulaConfirmacionFecha ? props.dataApe.flujo.cedulaConfirmacionFecha : props.dataApe.flujo.cedulaPrimerAprobador,
                cmp_stat: 'CONFIRMACION_FECHA_CONTRATACION'
            }
        }
        const bodyCorreo = {
            enviarA: props.dataApe.flujo.emailConfirmacionFecha ?
                [props.dataApe.flujo.emailConfirmacionFecha, 'profesional.reclutamiento@confipetrol.com'] : [props.dataApe.flujo.emailPrimerAprobador, 'profesional.reclutamiento@confipetrol.com'],
            tipo: "fechaContratacion",
            adjuntos: [],
            codigoAPE: props.id,
            data: {
                campo: props.dataApe.campo,
                codigoCargo: props.dataApe.codigoCargo,
                codigoAPE: props.id,
                anillo: props.dataApe.anilloReclutamiento,
                residencia: listaChequeo?.residencia ?? '',
                nombre: listaChequeo?.nombre ?? '',
                cedula: listaChequeo?.cedula ?? '',
                celular: listaChequeo?.telefono ?? '',
                correo: listaChequeo?.correo ?? '',
                tallaCamisa: listaChequeo?.tallaCamisa ?? '',
                tallaPantalon: listaChequeo?.tallaPantalon ?? '',
                tallaBotas: listaChequeo?.tallaBotas ?? '',
                fechaIngreso: new Date(props.dataApe.fechaIngreso._seconds * 1000).toISOString().split('T')[0]
            }
        }
        const correoData = {
            tipo: "asignacion",
            codigoAPE: props.solicitud,
            estado: 'VERIFICACION FECHA INGRESO',
            enviarA: [
                props.dataApe.flujo.emailReclutador,
                'profesional.reclutamiento@confipetrol.com'
            ]
        }
        try {
            Swal.fire({
                title: '¿Desea pasar al proceso de contratación?',
                html: `Una vez se apruebe el paso el proceso no prodrá regresar al estado actual.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, confirmar!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    props.setLoading(true);
                    await actualizarAPE(body);
                    await envioCorreoLider(bodyCorreo);
                    await envioCorreo(correoData);
                    props.setLoading(false);
                    props.toggle()
                    navigate('/home/proceso-seleccion');
                    Swal.fire(
                        'Finalizado!',
                        'Se ha finalizado el proceso de reclutamiento.',
                        'success'
                    )
                }
            })

        }
        catch (error) {
            console.log(error)
        }

    }


    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    if (loading) {return <Loading/>}
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Pasar a Contratación'}
                buttonTitle={'Confirmar'}
                // buttonLoading={!handleValidacionFinal()}
                buttonLoading={false}
                onClick={async () => {
                    pasoAContratacion()
                }}
            >       
                <Row>
                    <Col key={`col_datos`} lg='12'>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Datos Personales y Educación</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    {listadoAdjuntos.map((doc, index) => {
                        return (
                            <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                <AttachCardV2
                                    id={`${doc.key}`}
                                    file={fileExist(`${doc.key}`).file}
                                    subText={`${doc.name}`}
                                    apeId={props.id}
                                    attached={fileReadyToUpload(`${doc.key}`) || fileExist(`${doc.key}`).exists}
                                    fileList={props.fileList}
                                    setLoading={(e) => props.setLoading(e)}
                                    setFileList={(e) => { props.setFileList(e) }}
                                />
                            </Col>

                        )
                    })}
                    <Col key={`col_datos`} lg='12' style={{ marginTop: '10px' }}>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Datos Personales y Educación</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    {listadoAdjuntos2.map((doc, index) => {
                        return (
                            <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                <AttachCardV2
                                    id={`${doc.key}`}
                                    file={fileExist(`${doc.key}`).file}
                                    subText={`${doc.name}`}
                                    apeId={props.id}
                                    attached={fileReadyToUpload(`${doc.key}`) || fileExist(`${doc.key}`).exists}
                                    fileList={props.fileList}
                                    setLoading={(e) => props.setLoading(e)}
                                    setFileList={(e) => { props.setFileList(e) }}
                                />
                            </Col>

                        )
                    })}
                    <Col key={`col_datos`} lg='12' style={{ marginTop: '10px' }}>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Datos Personales y Educación</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Agencia SPE Colocado</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={agenciaSPE1 !== undefined ? agenciaSPE1 : ''} value={agenciaSPE1} onChange={(e) => setAgenciaSPE1(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Código SPE Colocado</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={codigoSPE1 !== undefined ? codigoSPE1 : ''} value={codigoSPE1} onChange={(e) => setCodigoSPE1(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Agencia SPE CCF1</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={agenciaSPE2 !== undefined ? agenciaSPE2 : ''} value={agenciaSPE2} onChange={(e) => setAgenciaSPE2(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Código SPE CCF1</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={codigoSPE2 !== undefined ? codigoSPE2 : ''} value={codigoSPE2} onChange={(e) => setCodigoSPE2(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Agencia SPE CCF2</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={agenciaSPE3 !== undefined ? agenciaSPE3 : ''} value={agenciaSPE3} onChange={(e) => setAgenciaSPE3(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Código SPE CCF2</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={codigoSPE3 !== undefined ? codigoSPE3 : ''} value={codigoSPE3} onChange={(e) => setCodigoSPE3(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Agencia SPE Sena</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={agenciaSPE4 !== undefined ? agenciaSPE4 : ''} value={agenciaSPE4} onChange={(e) => setAgenciaSPE4(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Código SPE Sena</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={codigoSPE4 !== undefined ? codigoSPE4 : ''} value={codigoSPE4} onChange={(e) => setCodigoSPE4(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Agencia SPE Alcaldía</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={agenciaSPE5 !== undefined ? agenciaSPE5 : ''} value={agenciaSPE5} onChange={(e) => setAgenciaSPE5(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Código SPE Alcaldía</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={codigoSPE5 !== undefined ? codigoSPE5 : ''} value={codigoSPE5} onChange={(e) => setCodigoSPE5(e.target.value)} />
                    </Col>
                    <Col lg='12' md='12' xs="12">
                        <Label for="exampleSelect">Analisis SPE</Label>
                        <Input type="textarea" name="text" id="inputTitulo" defaultValue={analisisSPE !== undefined ? analisisSPE : ''} value={analisisSPE} onChange={(e) => setAnalisisSPE(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Autocomplete
                            required
                            margin="dense"
                            options={['Área de Influencia', 'Municipio Aledaño', 'Departamental', 'Nacional']}
                            key={`key_Anillo`}
                            id={`select_Anillo`}
                            onChange={(event, newValue) => setAnillo(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} label={'Anillo'} margin="normal" />
                            )}
                            getOptionLabel={(option) => option}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option}
                                </React.Fragment>
                            )}
                        />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Autocomplete
                            required
                            margin="dense"
                            options={['Hidrocarburos', 'Energía', 'Alimentos', 'Obras Civiles', 'Oleoductos', 'Minero', 'Administrativo']}
                            key={`key_Sector`}
                            id={`select_Sector`}
                            onChange={(event, newValue) => setSector(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} label={'Sector'} margin="normal" />
                            )}
                            getOptionLabel={(option) => option}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option}
                                </React.Fragment>
                            )}
                        />
                    </Col>
                </Row>             
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalRevision);